export default "__VITE_ASSET__DwOnIJsw__"